import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Button, Menu, Popconfirm, Space } from "antd";
import { connect } from "react-redux";
// import logo from "../../assets/images/logo2.png";
import logo from "../../assets/images/asm.jpg";
// import { userOptions } from "../../utils/storageUtils";
import { menuConfig } from "../../config/menuConfig";
import styles from "./left-nav.module.css";
import { updateHeaderTitle } from "../../redux/actions/header";
import { logoutAction } from "../../redux/actions/auth";

const { SubMenu } = Menu;

class LeftNav extends Component {
  constructor(props) {
    super(props);
    // 本地测试数据版本
    this.keyPathMap = new Map();
    this.menuNodes = this.getMenuNodes_reduce(menuConfig);
  }

  /**
   * 菜单校验
   */
  isMenu = (item) => {
    //判断是否的菜单类型的权限
    //  console.log('isMenu', item);
    return item.type === 1;
  };

  /**
   * 累计累加 - 入参已经是树形结构
   *
   * pre是“上一个”的意思，先往pre中添加数据。完成之后再向第二个参数“[]”添加pre的数据。
   * 记得最后一定要
   * return pre
   * @param menuList
   */
  getMenuNodes_reduce = (menuList) => {
    let { pathname } = this.props.location;
    //这里指定默认路径，默认设置展开 '/content/novel' 菜单
    let path = "/search";

    return menuList.reduce((pre, item) => {
      if (!item.children || item.children.length === 0) {
        // 处理子菜单项
        if (this.isMenu(item)) {
          // 如果当前的href等于路由地址，或者路由地址中包含有当前key
          if (path === item.href || path.indexOf(item.href) === 0)
            // 更新redux中的headTitle状态. 面包屑路径类型
            this.props.updateHeaderTitle(item.name);
          if (item.href.length === 0) {
            item.href = "#";
          }
          // console.log('11111111111111 item', item.id, item.css);
          pre.push(
            // key - item 的唯一标志
            <Menu.Item key={item.id}>
              {/* to用于指定跳转页面，onClick用于更新面包屑或者title等 */}
              <Link
                to={item.href}
                onClick={() => {
                  // console.log(item.name);
                  this.props.updateHeaderTitle(item.name);
                  //设置选中效果
                  this.currentKey = item.id;
                }}
              >
                <Space>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "18px",
                    }}
                  >
                    {item.css}
                  </div>
                  <span>{item.name}</span>
                </Space>
              </Link>
            </Menu.Item>
          );
          this.keyPathMap.set(item.href, item.id);
        }
      } else {
        // 父级菜单的情况
        // 如果有children，那么递归遍历
        if (this.isMenu(item)) {
          // console.log('2222222222222 item', item.id,item.name);
          pre.push(
            <SubMenu
              key={item.id}
              title={
                <Space>
                  {item.css}
                  <span>{item.name}</span>
                </Space>
              }
            >
              {this.getMenuNodes_reduce(item.children)}
            </SubMenu>
          );
        }
      }
      return pre;
    }, []);
  };

  // 每次熏染的时候，重新选中菜单，重置currentKey的值
  findCurrentKey = () => {
    let { pathname } = this.props.location;
    // 目前用的测试属性，需要遍历树
    // 如果使用线上环境，遍历list即可
    this.currentKey = this.keyPathMap.get(pathname);
    // console.log("findCurrentKey", pathname, this.currentKey);
  };

  logout = () => {
    // console.log("退出登录");
    this.props.logoutAction();
  };

  render() {
    // 设置key，出现选中效果
    this.findCurrentKey();
    let currentKey = this.currentKey;

    return (
      <div style={{ height: "64px", overflow: "hidden", position: "relative" }}>
        <Link to="/search" className={styles.leftNavHeader}>
          <img
            src={logo}
            alt="logo"
            style={{ height: "50px", width: "50px" }}
          />
        </Link>
        <Menu
          // 内嵌模式
          // mode="inline"
          mode="horizontal"
          // 菜单主题，dark、light
          theme="light"
          // 当前选中的菜单项 key 数组，会有一个选中效果
          selectedKeys={[currentKey + ""]}
        >
          {this.menuNodes}
        </Menu>
        <Button
          style={{
            position: "absolute",
            top: "15px",
            right: "100px",
            borderRadius: "6px",
          }}
          type="link"
          onClick={() => window.location.reload(true)}
        >
          Reload
        </Button>
        <Popconfirm
          title="Are you sure to logout?"
          onConfirm={this.logout}
          okText="Yes"
          cancelText="No"
        >
          <Button
            style={{
              position: "absolute",
              top: "15px",
              right: "0px",
              borderRadius: "6px",
            }}
            // type="link"
          >
            Logout
          </Button>
        </Popconfirm>
      </div>
    );
  }
}
/*
 * withRouter 高阶组件：
 * 包装非路由组件，返回一个新的组件
 * 新的组件向非路由组件传递props的三个属性。
 * history/location/match
 * */
export default connect((state) => ({ title: state.headerTitle.title }), {
  updateHeaderTitle,
  logoutAction,
})(withRouter(LeftNav));
